import { Box } from "@mui/system";
import React from "react";
import flashappOveralIcon from "../../../../assests/Images/flasapp-hanging-iconY.png";

/**
 * Flash seal centered on the Core Team (#181818) → DevTeam (black) color seam.
 * Also acts as a scroll-coin dock target (data-flash-seam-target).
 */
export default function TeamSeamCoin() {
  return (
    <Box
      aria-hidden
      sx={{
        position: "relative",
        height: 0,
        zIndex: 25,
        pointerEvents: "none",
        overflow: "visible",
      }}
    >
      <Box
        data-flash-seam-target="team"
        sx={{
          position: "absolute",
          left: { lg: "12%", xs: "50%" },
          top: 0,
          transform: "translate(-50%, -50%)",
          width: {
            xs: "72px",
            sm: "86px",
            md: "100px",
            lg: "117px",
          },
          height: {
            xs: "72px",
            sm: "86px",
            md: "100px",
            lg: "117px",
          },
        }}
      >
        <img
          className="rotating"
          src={flashappOveralIcon}
          alt=""
          style={{
            width: "100%",
            height: "100%",
            display: "block",
            filter: "drop-shadow(0 0 18px rgba(251, 191, 4, 0.45))",
          }}
        />
      </Box>
    </Box>
  );
}
